<mat-selection-list #permissionList (selectionChange)="emitPermissionsChanged(permissionList.selectedOptions.selected)" [disabled]="formDisabled">
  <mat-list-option
    togglePosition="before"
    disableRipple="true"
    value="0"
    [selected]="permissionSet >= Permissions.hasOnlineAccess"
    [disabled]="!canEditOnlineAccess"
  >
    <span class="tooltip-container">Contact can log in and carry out the following actions: <mat-icon [matTooltip]="">information</mat-icon></span>
  </mat-list-option>
  @if (applicationPermissions.noOnlineUsers) {
    <mat-error>At least one contact on this account must have online access</mat-error>
  }
  @for (group of applicationPermissions.groups; track $index) {
    <div mat-subheader>
      {{ group.groupName }}
      <mat-checkbox
        [disabled]="formDisabled || permissionSet === Permissions.hasNoOnlineAccess || !isPermissionGroupEnabled(group.groupId)"
        [checked]="group.allSelected"
        [indeterminate]="group.indeterminate"
        (change)="toggleGroup(group, $event.checked)"
        title="Toggle currently selected items in the group"
        color="primary"
      />
    </div>
    @for (permission of group.permissions; track $index) {
      @if (permissionValidForCurrentAccount(group.groupId, permission.permissionValue)) {
        <mat-list-option
          [disabled]="permissionSet === Permissions.hasNoOnlineAccess || !isPermissionEnabled(permission.permissionValue)"
          togglePosition="before"
          disableRipple="true"
          [selected]="permission.selected"
          [value]="permission.permissionValue"
        >
          {{ permission.permissionName }}

          @if (permission.invalid) {
            <mat-error>At least one contact in this account must have this permission</mat-error>
          }
        </mat-list-option>
      }
    }
  }
</mat-selection-list>